import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, mergeProps as _mergeProps, withKeys as _withKeys, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50176ea4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex flex-col gap-4 p-4 modal-content w-full items-center overflow-y-auto max-h-[70vh]" }
const _hoisted_3 = { class: "flex flex-col md:flex-row gap-4 items-start md:items-center w-full" }
const _hoisted_4 = { class: "flex flex-col gap-4 bg-[#f0f0f4] p-4 rounded-lg w-full max-w-[95%] md:max-w-[85%] shadow-inner min-w-0" }
const _hoisted_5 = { class: "flex flex-nowrap overflow-x-auto custom-scrollbar gap-2 pb-2 items-center w-full" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex flex-col gap-2 w-full max-h-[280px] overflow-y-auto custom-scrollbar pr-1" }
const _hoisted_8 = { class: "flex-1 flex items-center justify-center px-2 h-[36px] bg-white border border-gray-400 rounded text-sm font-medium text-gray-700" }
const _hoisted_9 = { class: "border border-red-500 rounded-full bg-white flex-shrink-0" }
const _hoisted_10 = { class: "flex w-full justify-center pt-1 pb-1 flex-shrink-0" }
const _hoisted_11 = { class: "flex justify-end gap-4" }

import { ref, watch, computed, PropType } from 'vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import EditableHeader from '@/components/designSystem/Inputs/EditableHeader.vue'
import { mdiMenuDown, mdiMinus, mdiPlus, mdiTrashCanOutline } from '@mdi/js'
import { DSAttendanceMonitoringType } from '@/constants/ds-attendance.constants'

// Tipagens alinhadas com o Payload do Backend
interface SheetTemplateFields {
  columns: string[]
  rows: number
}

interface SheetData {
  id?: number
  name: string
  templateFields: SheetTemplateFields
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SheetTemplateModal',
  props: {
  show: { type: Boolean, required: true },
  initialData: { type: Object as PropType<SheetData | null>, default: null },
  monitoringType: {
    type: String as PropType<DSAttendanceMonitoringType>,
    default: DSAttendanceMonitoringType.FOLHA
  }
},
  emits: ['close', 'save'],
  setup(__props, { emit }) {

const props = __props;





const modelName = ref('Novo Modelo de Folha')
const columns = ref<string[]>([])
const rows = ref<number>(0)

const activeColIndex = ref<number | null>(null)
const searchText = ref('')

const FIXED_COLUMNS = computed(() => {
  const base = ['Nome do médico', 'CRM', 'Data', 'Jornada início', 'Jornada Fim', 'Entrada']
  if (props.monitoringType !== DSAttendanceMonitoringType.EXTERNAL_APP) {
    base.push('Ass. e Carimbo Entrada')
  }
  base.push('Saída')
  if (props.monitoringType !== DSAttendanceMonitoringType.EXTERNAL_APP) {
    base.push('Ass. e Carimbo Saída')
  }
  return base
})
const columnOptions = ref(['Setor', 'Especialidade', 'Valor do plantão'])

const isFixedColumn = (columnName: string) => FIXED_COLUMNS.value.includes(columnName)

// Controlo do Modal
watch(
  () => props.show,
  (isShowing) => {
    if (isShowing) {
      if (props.initialData?.templateFields) {
        templateId.value = props.initialData.id
        modelName.value = props.initialData.name
        columns.value = [...props.initialData.templateFields.columns]
        rows.value = props.initialData.templateFields.rows
      } else {
        templateId.value = undefined
        modelName.value = 'Novo Modelo de Folha'
        columns.value = [...FIXED_COLUMNS.value]
        rows.value = 3
      }
    }
  }
)

const close = () => {
  activeColIndex.value = null
  emit('close')
}

// O Payload aqui já está aderente ao Backend (templateFields com JSONB)
const templateId = ref<number | undefined>(undefined)

const save = () => {
  emit('save', {
    id: templateId.value,
    name: modelName.value,
    templateFields: {
      columns: columns.value,
      rows: rows.value
    }
  })
}

const handleSaveHeader = (newName: string) => {
  modelName.value = newName
}

// Lógica de Linhas e Colunas
const addColumn = () => columns.value.push('')
const removeRow = () => {
  if (rows.value > 0) rows.value--
}
const addRow = () => rows.value++

const handleMenuOpen = (open: boolean, index: number, col: string) => {
  if (open && !isFixedColumn(col)) {
    activeColIndex.value = index
    searchText.value = col
  } else if (!open && activeColIndex.value !== null) {
    const trimmed = typeof searchText.value === 'string' ? searchText.value.trim() : ''
    if (trimmed) {
      columns.value[activeColIndex.value] = trimmed
      if (!columnOptions.value.includes(trimmed)) {
        columnOptions.value.push(trimmed)
      }
    }
    activeColIndex.value = null
  }
}

const onListItemSelect = (value: string) => {
  if (activeColIndex.value === null || !value) return
  if (!columnOptions.value.includes(value)) return

  columns.value[activeColIndex.value] = value
  activeColIndex.value = null
}

const onConfirmCustomText = () => {
  if (activeColIndex.value === null) return
  const trimmed = typeof searchText.value === 'string' ? searchText.value.trim() : ''
  if (!trimmed) return

  columns.value[activeColIndex.value] = trimmed
  if (!columnOptions.value.includes(trimmed)) {
    columnOptions.value.push(trimmed)
  }
  activeColIndex.value = null
}

const handleRemoveActiveColumn = () => {
  if (activeColIndex.value !== null) {
    columns.value.splice(activeColIndex.value, 1)
    activeColIndex.value = null
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(ModalVue, {
    modalActive: __props.show,
    onClose: close,
    maxWidth: "max-w-6xl",
    hasHeaderBorder: "",
    hasFooterBorder: ""
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(EditableHeader, {
          modelValue: modelName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelName).value = $event)),
          placeholder: "Nome do modelo",
          onSave: handleSaveHeader
        }, null, 8, ["modelValue"])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(OutlinedButton, {
          text: "Fechar",
          width: "100px",
          height: "42px",
          class: "text-primary border-primary",
          onClick: close
        }),
        _createVNode(FilledButton, {
          text: "Salvar",
          width: "100px",
          height: "42px",
          color: "primary",
          onClick: save
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "relative flex-shrink-0"
                }, [
                  _createVNode(_component_v_menu, {
                    "model-value": activeColIndex.value === index,
                    "close-on-content-click": false,
                    location: "bottom start",
                    "onUpdate:modelValue": (open) => handleMenuOpen(open, index, col)
                  }, {
                    activator: _withCtx(({ props: menuProps }) => [
                      _createElementVNode("div", _mergeProps(menuProps, {
                        class: ["flex items-center justify-between px-3 py-2 bg-white border border-gray-400 rounded cursor-pointer min-w-[120px] hover:border-primary transition-colors", {
                      'opacity-80 cursor-not-allowed bg-gray-50 pointer-events-none':
                        isFixedColumn(col)
                    }]
                      }), [
                        _createElementVNode("span", {
                          class: _normalizeClass(["text-sm font-medium whitespace-nowrap", col ? 'text-gray-700' : 'text-gray-400 italic'])
                        }, _toDisplayString(col || 'Nova coluna'), 3),
                        _createVNode(_component_v_icon, {
                          class: _normalizeClass(isFixedColumn(col) ? 'text-gray-400' : 'text-gray-600'),
                          size: "20"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(mdiMenuDown)), 1)
                          ]),
                          _: 2
                        }, 1032, ["class"])
                      ], 16)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_sheet, { class: "w-[300px] pa-2 rounded-lg" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_combobox, {
                            modelValue: searchText.value,
                            "onUpdate:modelValue": [
                              _cache[1] || (_cache[1] = ($event: any) => ((searchText).value = $event)),
                              onListItemSelect
                            ],
                            items: columnOptions.value,
                            onKeydown: _withKeys(onConfirmCustomText, ["enter"]),
                            placeholder: "Selecionar ou digitar...",
                            variant: "outlined",
                            density: "compact",
                            "hide-details": "",
                            autofocus: "",
                            class: "mb-1"
                          }, null, 8, ["modelValue", "items", "onKeydown"]),
                          (activeColIndex.value !== null && !isFixedColumn(columns.value[activeColIndex.value]))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createVNode(_component_v_divider, { class: "my-2" }),
                                _createVNode(OutlinedButton, {
                                  text: "Excluir coluna",
                                  width: "100%",
                                  height: "36px",
                                  class: "text-red-500 border-red-500",
                                  onClick: handleRemoveActiveColumn
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      size: "18",
                                      class: "mr-[6px] fill-current text-red-500"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(mdiTrashCanOutline)), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["model-value", "onUpdate:modelValue"])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (n) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: n,
                  class: "flex items-center gap-3 w-full flex-shrink-0"
                }, [
                  _createElementVNode("div", _hoisted_8, " Linha " + _toDisplayString(n), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      class: "w-[34px] h-[34px] flex items-center justify-center rounded-full text-red-500 hover:bg-red-50 transition-colors",
                      onClick: removeRow
                    }, [
                      _createVNode(_component_v_icon, {
                        size: "24",
                        class: "text-red-500"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(mdiMinus)), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                "data-testid": "add-row-button",
                class: "flex w-[132px] items-center justify-center gap-3 h-[36px] px-[16px] rounded bg-white text-[#2F7F91] text-sm font-medium transition-colors hover:bg-gray-50 border border-solid border-[#2f7f91]",
                onClick: addRow
              }, [
                _createVNode(_component_v_icon, {
                  size: "16",
                  class: "text-[#2F7F91]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(mdiPlus)), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(" Nova linha ")
              ])
            ])
          ]),
          _createElementVNode("button", {
            "data-testid": "add-column-button",
            class: "flex-shrink-0 flex items-center justify-center gap-1 h-[38px] px-3 rounded bg-white text-[#2F7F91] text-sm font-medium transition-colors hover:bg-gray-50 border border-solid border-[#2f7f91] w-full md:w-auto",
            onClick: addColumn
          }, [
            _createVNode(_component_v_icon, {
              size: "16",
              class: "text-[#2F7F91]"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(mdiPlus)), 1)
              ]),
              _: 1
            }),
            _createTextVNode(" Nova col. ")
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})